/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessUnitDto
 */
export interface BusinessUnitDto {
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitDto
     */
    parentName?: string | null;
    /**
     * 
     * @type {Array<BusinessUnitDto>}
     * @memberof BusinessUnitDto
     */
    children?: Array<BusinessUnitDto> | null;
}

/**
 * Check if a given object implements the BusinessUnitDto interface.
 */
export function instanceOfBusinessUnitDto(value: object): value is BusinessUnitDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BusinessUnitDtoFromJSON(json: any): BusinessUnitDto {
    return BusinessUnitDtoFromJSONTyped(json, false);
}

export function BusinessUnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'parentName': json['parentName'] == null ? undefined : json['parentName'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(BusinessUnitDtoFromJSON)),
    };
}

export function BusinessUnitDtoToJSON(json: any): BusinessUnitDto {
    return BusinessUnitDtoToJSONTyped(json, false);
}

export function BusinessUnitDtoToJSONTyped(value?: BusinessUnitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'parentId': value['parentId'],
        'parentName': value['parentName'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(BusinessUnitDtoToJSON)),
    };
}

